import React from "react";
import styles from "./Label.module.scss";
import classNames from "classnames";

interface LabelProps {
    dropdownId: string;
    required?: boolean;
    children: React.ReactNode;
}

const Label = ({ dropdownId, required, children }: LabelProps) => {
    return (
        <label
            className={classNames(styles["label"], {
                [styles["label--required"]]: required,
            })}
            htmlFor={dropdownId}
        >
            {children}
        </label>
    );
};

export default Label;
